import React, { useState, useEffect, useRef } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { IoMicSharp, IoClose } from "react-icons/io5";
import { MdRecordVoiceOver } from "react-icons/md";

export default function VoiceSearchInput({ value, setInputSearchValue, fromPage }) {
  const [showHint, setShowHint] = useState(false);
  const silenceTimerRef = useRef(null);
  const autoCloseTimerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [fade, setFade] = useState(true);
  const [placeholderText, setPlaceholderText] = useState("Store");
  const { transcript, listening, resetTranscript } = useSpeechRecognition();


  useEffect(() => {
    if (!listening && transcript) {
      setInputSearchValue(transcript.trim());
      setOpen(false);
    }
  }, [listening, transcript]);

  const openMicModal = () => {
    resetTranscript();
    setOpen(true);
    setShowHint(false);

    SpeechRecognition.startListening({
      continuous: false,
      language: "en-IN",
    });

    // If user doesn't speak for 3 seconds
    silenceTimerRef.current = setTimeout(() => {
      if (!transcript) {
        setShowHint(true);
      }
    }, 1000);
    autoCloseTimerRef.current = setTimeout(() => {
      if (!transcript) {
        SpeechRecognition.stopListening();
        setOpen(false);
      }
    }, 10000);
  };

  useEffect(() => {
    const words = ["Store", "Service", "Product"];
    let index = 0;

    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        index = (index + 1) % words.length;
        setPlaceholderText(words[index]);
        setFade(true);
      }, 300);
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  const closeModal = () => {
    SpeechRecognition.stopListening();
    clearTimeout(autoCloseTimerRef.current);
    setOpen(false);
  };

  useEffect(() => {
    if (transcript) {
      clearTimeout(silenceTimerRef.current);
      clearTimeout(autoCloseTimerRef.current);
      setShowHint(false);
    }
  }, [transcript]);


  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return <p>Speech Recognition not supported</p>;
  }
  const handleChange = (event) => {
    setInputSearchValue(event.target.value);
  };

  const restartListening = () => {
    resetTranscript();
    setShowHint(false);
    clearTimeout(autoCloseTimerRef.current);
    SpeechRecognition.startListening({
      continuous: false,
      language: "en-IN",
    });
    silenceTimerRef.current = setTimeout(() => {
      if (!transcript) {
        setShowHint(true);
      }
    }, 3000);

    autoCloseTimerRef.current = setTimeout(() => {
      if (!transcript) {
        SpeechRecognition.stopListening();
        setOpen(false);
      }
    }, 10000);
  };

  return (
    <>
      <div className="searchStores p-2 voiceInputBox" >
        <div className="inputWrapper" style={{ position: 'relative' }}>
          <input
            className="searchInput"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
            placeholder={`Search ${fromPage == "mainSearch" ? "Near By" : fromPage} `}
            value={value}
            onChange={handleChange}
          />
          {

            fromPage == "mainSearch" && value == "" && (
              <span
                className={`placeholderDynamic ${fade ? "fade-in" : "fade-out"}`}
                style={{
                  position: 'absolute',
                  left: '99px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#999',
                }}
              >

                "{placeholderText}"
              </span>
            )}
        </div>
        <div className="searchMicIcon" onClick={openMicModal}>
          <IoMicSharp size={20} />
        </div>
      </div>

      {open && (
        <div className="micModalOverlay">
          <div className="micModal">
            <div className="modalHeader">
              <IoClose size={22} onClick={closeModal} />
            </div>

            <div className="micIcon" onClick={!listening ? restartListening : undefined}>
              {listening ? (
                <MdRecordVoiceOver color="#4E26A3" size={60} />
              ) : (
                <span>
                  <IoMicSharp color="#4E26A3" size={60} />
                </span>
              )}
            </div>


            <p className="spokenText">
              {transcript
                ? transcript
                : showHint
                  ? "Say something…"
                  : "I'm listening"}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

